import { render } from "./Exit.vue?vue&type=template&id=a36878d4&scoped=true"
import script from "./Exit.vue?vue&type=script&lang=js"
export * from "./Exit.vue?vue&type=script&lang=js"

import "./Exit.vue?vue&type=style&index=0&id=a36878d4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a36878d4"]])

export default __exports__